import Iodine from '@caneara/iodine';

const iodine = new Iodine();

iodine.rule('consent', (value) => [1, '1', true, 'true'].includes(value));
// cette regex match un cp de 5 chiffres OU un nom de villes autorisant les lettres, les diacritiques, les apostrophes et les espaces
iodine.rule('zipOrCity', (value) => new RegExp(/^\d{5}|^[a-zA-Z\- 'ÀÂÄÉÈÊËÎÏÌÍĮĪÔÖÒÓÕÛÙÜÇĆČàâäéèêëîïìíįīôöòóõûùüçćč]+$/).test(value));
// cette regex matche 01 23 45 67 89 OU +331 23 45 67 89
iodine.rule('trybaPhone', (value) => new RegExp(/^(?:\d\d\s){4}(?:\d\d)$|^(?:\+33\d\s)(?:\d\d\s){3}(?:\d\d)$/).test(value));
iodine.rule('noPlusInEmail', (value) => !(new RegExp(/\+/).test(value)));
iodine.rule('noNumber', (value) => new RegExp(/^[A-Za-z\-ÀÂÄÉÈÊËÎÏÌÍĮĪÔÖÒÓÕÛÙÜÇĆČàâäéèêëîïìíįīôöòóõûùüçćč\s]*$/).test(value));
iodine.rule('justNumber', (value) => new RegExp(/^[0123456789]*$/).test(value));
iodine.rule('leastOneLetter', (value) => new RegExp(/^[a-zA-Z\d\-ÀÂÄÉÈÊËÎÏÌÍĮĪÔÖÒÓÕÛÙÜÇĆČàâäéèêëîïìíįīôöòóõûùüçćč\s']+$/).test(value));

const iodineErrorMessages = {
    required: 'Ce champ est requis',
    truthy: 'Veuillez sélectionner au moins un élément',
    consent: 'Veuillez choisir un moyen de vous recontacter',
    email: 'Veuillez saisir une adresse email valide',
    noPlusInEmail: 'L’email ne doit pas contenir de "+"',
    regexMatch: 'Le champ n’est pas correct',
    zipOrCity: 'Le champ n’est pas correct',
    trybaPhone: 'Le numéro doit être composé de 10 chiffres',
    noNumber: 'Ce champ ne doit pas contenir de chiffres.',
    justNumber: 'Ce champ ne doit contenir que des chiffres.',
    leastOneLetter: 'Ce champ doit contenir au moins une lettre et un chiffre mais pas de caractères spéciaux.',
};

const verifyTrybaPhoneCapAdresse = async (phone: string, rules: string[]): Promise<boolean> => {
    if (phone && iodine.assert(phone, rules) && new RegExp(/^06|07/).test(phone)) {
        const response = await fetch(`/api/validation/phone/?number=${phone}`);
        try {
            if (!response.ok) {
                throw new Error(response.statusText);
            }
            const { isValid } = (await response.json()) as { isValid: boolean };
            return isValid;
        } catch (e) {
            console.log(e);
        }
    }
    return true;
};

const zipOrCityMask = (input: string): string => {
    if (new RegExp(/^\d/).test(input)) {
        return '99999';
    } else {
        return '';
    }
};

const trybaPhoneMask = (input: string): string => {
    if (new RegExp(/^\+|^\+3|^\+33/).test(input)) {
        return '+339 99 99 99 99';
    } else {
        return '09 99 99 99 99';
    }
};

const fieldWasUpdated = (element: HTMLElement): boolean => {
    if ((element.parentNode as HTMLDivElement).previousElementSibling?.classList.contains('form-error')) {
        return false;
    }
    return true;
};

// Valide un champ "location" au format "75000 Paris" (issu d'une sélection autocomplete ou d'une saisie manuelle conforme)
const isValidZipCityLocation = (value: string): boolean => /^\d{5}\s+\S.*$/.test((value ?? '').trim());

iodine.setErrorMessages(iodineErrorMessages);

export { iodine, verifyTrybaPhoneCapAdresse, zipOrCityMask, trybaPhoneMask, fieldWasUpdated, isValidZipCityLocation };
